import { useMemo } from 'react';
import { Table } from 'antd';
import { PermissionTableProps } from './type';
import { useTranslation } from 'react-i18next';
import useStore from '../../store/useStore';
import EditOutlined from '@ant-design/icons/EditOutlined';
import DeleteOutlined from '@ant-design/icons/DeleteOutlined';
import { IPermission, Actions } from '../../interfaces/global';
import './PermissionTable.scss';

export const columnData = (columnTitle: string, key: string, options: object = {}) => ({
  title: columnTitle,
  key,
  dataIndex: key,
  ...options
});

const PermissionTable = ({ loading, dataSource, setPage, total }: PermissionTableProps) => {
  const { t } = useTranslation();
  const { setPaginate, paginate, setUi } = useStore();

  const openModalPermission = (permission: IPermission) => {
    setUi({ showModalPermission: true, permissionSelected: permission, action: Actions.Edit });
  };

  const openModalDeletePermission = (permission: IPermission) => {
    setUi({ showModalDeletePermission: true, permissionSelected: permission });
  };

  const renderActions = (i: string, permission: IPermission) => {
    return (
      <div className="actions">
        <EditOutlined className="actions__icon" onClick={() => openModalPermission(permission)} />
        <DeleteOutlined className="actions__icon" onClick={() => openModalDeletePermission(permission)} />
      </div>
    );
  };

  const columns = useMemo(
    () => [
      columnData(t('table.permission.name'), 'name'),
      columnData(t('table.permission.description'), 'description', {
        render: (description: string) => {
          return description ? <span>{description}</span> : <span>-</span>;
        }
      }),
      columnData(t('table.permission.actions'), 'actions', {
        align: 'center',
        render: renderActions
      })
    ],
    []
  );

  const onChange = (pagination: any, filters: any, sorter: any) => {
    const { current, pageSize } = pagination;
    setPaginate({ currentPage: current, perPage: pageSize });
    setPage(current);
  };

  return (
    <Table
      className="table-permission"
      loading={loading}
      columns={columns}
      dataSource={dataSource}
      onChange={onChange}
      pagination={{
        total,
        current: Number(paginate.currentPage),
        pageSize: Number(paginate.perPage),
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '75', '100']
      }}
      scroll={{ y: 'calc(100vh  - 300px)' }}
      bordered
      rowKey="name"
      key="table-permission"
    />
  );
};

export default PermissionTable;
